import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HeaderComponent } from '../shared/header.component';
import { GroupDto, UserDto } from '@oracychampions/api-interfaces';
import { Observable, map } from 'rxjs';
import { CardComponent } from '../shared/card.component';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'oc-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, CardComponent],
  template: `
    <div class="container-fluid oc-dashboard-container">
      <h1 class="mb-4 page-header">Dashboard</h1>
      <div class="oc-dashboard-grid">
        <oc-card
          *ngFor="let group of groups$ | async"
          [mainTitle]="group.name"
          [subTitle]="yearName(group.year)"
          icon="tablerUsers"
          [routerLink]="['/group', group.id]"
        ></oc-card>
        <oc-card *ngIf="role === 0" mainTitle="Admin" icon="tablerTool" [routerLink]="['/admin']"></oc-card>
        <oc-card *ngIf="superadmin" mainTitle="Super Admin" icon="tablerBolt" [routerLink]="['/superadmin']"></oc-card>
      </div>
    </div>
  `,
  styles: `
    oc-card {
      cursor: pointer;
    }

    .oc-dashboard-container {
      padding: 2.5rem 5%;
    }

    .oc-dashboard-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-template-rows: repeat(auto, 1fr);
      grid-auto-rows: 1fr;
      gap: 1.1rem;
      justify-content: start;
      
    }
  `,
})
export class DashboardComponent {
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);

  public groups$: Observable<GroupDto[]>;

  public role = (this.auth.auth$.getValue()?.user as UserDto).role;
  public superadmin = (this.auth.auth$.getValue()?.user as UserDto).superadmin ?? false;

  constructor() {
    this.groups$ = this.route.data.pipe(
      map((data) => data['groups']),
      map((groups) => {
        return groups
          .sort((a: GroupDto, b: GroupDto) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .sort((a: GroupDto, b: GroupDto) => {
            return a.year - b.year;
          });
      }),
    );
  }

  yearName(year: number): string {
    return year === 0 ? 'Reception' : `Year ${year}`;
  }
}
